import { render, staticRenderFns } from "./beat-drift-4.vue?vue&type=template&id=05cd6e81&scoped=true&"
import script from "./beat-drift-4.vue?vue&type=script&lang=js&"
export * from "./beat-drift-4.vue?vue&type=script&lang=js&"
import style0 from "./beat-drift-4.vue?vue&type=style&index=0&id=05cd6e81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd6e81",
  null
  
)

export default component.exports